export default {
  methods: {
    generatePointsLabel(numberOfPoints) {
      return numberOfPoints === 1
        ? this.translate('onePoint')
        : this.translate('numberOfPoints', { num: numberOfPoints });
    },
    generateOptions({ values, valueAbbreviations, type }) {
      return values.map((value, index) => ({
        id: index + 1,
        label: type === 'points' ? this.generatePointsLabel(value) : this.translate(value),
        value: valueAbbreviations?.[index] || value,
      }));
    },
    getSelectedEstimateSystem(projectId) {
      return this.$store.getters.getEstimateSystemForProject(projectId);
    },
    getEstimateOptions(projectId) {
      return this.estimateOptionsMap[this.getSelectedEstimateSystem(projectId)] || [];
    },
    // returns estimate systems available for current context based on whether cards from multiple projects can be displayed or not
    getAvailableEstimateSystems() {
      const availableSystemKeys = [];
      const baseSystemKeys = Object.keys(this.$constants.estimateSystems);

      // board -> only display estimate systems of project which board belongs to
      if (this.$route.name === this.$constants.routeNames.board) {
        const { project_id = '' } = this.$store.getters.currentBoard;
        const selectedSystemKey = this.getSelectedEstimateSystem(project_id);
        if (selectedSystemKey) availableSystemKeys.push(selectedSystemKey);
      } else {
        // views/my-work/members-work -> display estimate systems of projects selected by space filter
        // or display all of them if no space filter is selected
        const projectsSelectedByFilter =
          (this.newFilter || this.currentFilters)?.include?.projects || [];
        projectsSelectedByFilter.forEach((projectId) => {
          // check if all estimate systems are already included in label
          if (availableSystemKeys.length === baseSystemKeys.length) return;

          // get estimate system of the project selected by filter
          const projectsSystemKey = this.getSelectedEstimateSystem(projectId);

          // if estimate system is not yet included in available ones, add it
          if (projectsSystemKey && !availableSystemKeys.includes(projectsSystemKey))
            availableSystemKeys.push(projectsSystemKey);
        });
      }

      return availableSystemKeys.length
        ? availableSystemKeys
            // sort available esimtate systems in the same order as ones defined in constants
            .sort((keyA, keyB) => baseSystemKeys.indexOf(keyA) - baseSystemKeys.indexOf(keyB))
            // map estimate system keys to objects
            .map((key) => this.$constants.estimateSystems[key])
        : Object.values(this.$constants.estimateSystems);
    },
    // generates label to be used in filter dropdowns and in filter pills
    generateEstimateLabelForFilters(index) {
      const pointsArray = [];
      let tshirtLabel = '';

      this.getAvailableEstimateSystems().forEach(({ values, type, labelAbbreviation }) => {
        if (type === 'points') pointsArray.push({ value: values[index], abbrv: labelAbbreviation });
        else tshirtLabel = this.translate(values[index]);
      });

      const pointsLabel = pointsArray.some((point) => point !== 1)
        ? this.translate('points')
        : this.translate('point');

      // abbrv => abbreviation for the estimate system (e.g. 'fib.' for fibonacci)
      const pointsCount = pointsArray.reduce((acc, { value, abbrv }, i) => {
        // check if current value is the same as the previous one to avoid repeating it
        if (pointsArray?.[i - 1] === value) return acc;

        // determine how points should be sperated (comma or 'or')
        let delimiter;
        switch (i) {
          case 0:
            delimiter = '';
            break;
          case pointsArray.length - 1:
            delimiter = ` ${this.translate('or').toLowerCase()} `;
            break;
          default:
            delimiter = ', ';
        }

        return `${acc}${delimiter}${value} ${abbrv}`;
      }, '');

      if (!pointsArray.length) return tshirtLabel;
      if (!tshirtLabel) return `${pointsCount} ${pointsLabel}`;
      return `${tshirtLabel} (${pointsCount} ${pointsLabel})`;
    },
  },
  computed: {
    estimateOptionsMap() {
      // options to be used as items in dropdowns for each estimate system
      // e.g. { fibonacci: [{id: 1, label: '1 point'}, ...] }
      return Object.fromEntries(
        Object.entries(this.$constants.estimateSystems).map(([systemName, system]) => [
          systemName,
          this.generateOptions(system),
        ])
      );
    },
    estimateDefaultIcon() {
      return { src: 'clock', color: 'bg-icon-default' };
    },
  },
};
